import { HttpService } from '@/utils/http/index'
import { useStore } from '@/store/index'

const store = useStore()

const $http = new HttpService()

// 获取所有资质类型
export const getTypeListApi = (params: object = {}) => $http.get('/cake_api/mold_list', params)

// 获取审核列表
export const getCheckListApi = (params: object = {}) => $http.get('/cake_api/contracts_list', params)

// 商户/商务端保存资质
// @ts-ignore
export const saveContentApi = (data: object = {}) => $http.post(`${store.state.user.userInfo.user_type == 2 ? '/cake_api/add_check_contracts' : '/cake/setMsg'}`, data)

// 保存审核结果
export const saveCheckApi = (data: object = {}) => $http.post('/cake_api/check_approve', data)

// 获取品牌下资质列表，当用户类型为商户时根据 listType 判断获取列表：1-资质列表，2-审核记录
// @ts-ignore
export const getQualificationListApi = (params: object = {}) => $http.post(`${store.state.user.userInfo.user_type == 2 ? params.listType == 1 ? '/cake_api/labelList' : '/cake_api/contracts_goods_list' : '/cake/labelList'}`, params)

/**
 * 根据身份证图片识别信息
 * @param img_url 图片地址
 * @param code IdCard-身份证， BusinessLicense-营业执照
 * */
export const getInfoByIdCardApi = (img_url: string, code: string) => $http.get('/cake_api/aliyunDispose', { img_url, code })

// 提交法人资质下单申请
export const applyOwnerCertificateDownloadApi = () => $http.get('/admin/enterprise_information_dow')

// 获取法人资质下单申请列表
export const getOwnerCertificateDownloadApplyListApi = (params: object = {}) => $http.get('/admin/enterprise_information_list', params)
